import { fromJS } from 'immutable';

export const initialState = fromJS({
  loading: false,
});

function mainReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_LOADING':
      // debugger;
      return state.set('loading', action.loading);
    default:
      return state
  }
}

export default mainReducer;



// WEBPACK FOOTER //
// ./src/containers/App/Reducers/mainReducer.js